//
// DataState.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "../../export/ExportRequests";
import "./QueryRequest";
import "./QueryState";

var DataState = createModule("BIRD::DataState", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        queryStates: [1],
        exportRequests: 1,
        queryRequests: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default DataState;
